import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import MediaDisplay from "@/components/drops/view/item/content/media/MediaDisplay";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropPartContentMediasProps {
  readonly activePart: ApiDropPart;
  readonly disableMediaInteraction?: boolean | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly imageScale?: ImageScale | undefined;
}
const WaveDropPartContentMedias: React.FC<WaveDropPartContentMediasProps> = t0 => {
  const $ = _c(12);
  const {
    activePart,
    disableMediaInteraction: t1,
    isCompetitionDrop: t2,
    imageScale: t3
  } = t0;
  const disableMediaInteraction = t1 === undefined ? false : t1;
  const isCompetitionDrop = t2 === undefined ? false : t2;
  const imageScale = t3 === undefined ? ImageScale.AUTOx450 : t3;
  if (!activePart.media.length) {
    return null;
  }
  const t4 = `${activePart.content ? "tw-mt-3" : "tw-mt-1"} tw-space-y-3`;
  let t5;
  if ($[0] !== activePart.media || $[1] !== disableMediaInteraction || $[2] !== imageScale || $[3] !== isCompetitionDrop) {
    let t6;
    if ($[5] !== disableMediaInteraction || $[6] !== imageScale || $[7] !== isCompetitionDrop) {
      t6 = (media, i) => <div key={`part-${i}-media-${media.url}`} className="tw-flex tw-h-64">{disableMediaInteraction ? <MediaDisplay media_mime_type={media.mime_type} media_url={media.url} disableMediaInteraction={disableMediaInteraction} imageScale={imageScale} /> : <DropListItemContentMedia media_mime_type={media.mime_type} media_url={media.url} isCompetitionDrop={isCompetitionDrop} imageScale={imageScale} />}</div>;
      $[5] = disableMediaInteraction;
      $[6] = imageScale;
      $[7] = isCompetitionDrop;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t5 = activePart.media.map(t6);
    $[0] = activePart.media;
    $[1] = disableMediaInteraction;
    $[2] = imageScale;
    $[3] = isCompetitionDrop;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default WaveDropPartContentMedias;